(function () {
  function markLoaded(img) {
    img.classList.add('img-loaded');
    var area = img.closest('.product-card__image-area');
    if (area) area.classList.add('img-loaded');
  }

  function initImages(root) {
    (root || document).querySelectorAll('.product-card__image').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        markLoaded(img);
      } else {
        img.addEventListener('load', function () { markLoaded(img); }, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initImages(); });
  } else {
    initImages();
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        node.querySelectorAll('.product-card__image').forEach(function (img) {
          if (img.complete && img.naturalWidth > 0) {
            markLoaded(img);
          } else {
            img.addEventListener('load', function () { markLoaded(img); }, { once: true });
          }
        });
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();